import { getKey } from "pax-ui/core";
import { Exception } from "src/app/shared/store/shared/http-request-state";
import {
  CreateApplicationFailedException,
  ExceptionName,
} from "../../backend/shared/exceptions/exception.model";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ApplicantDto } from "src/app/quote/term-life-insurance/services/backend/response/models/shared-quote-response.dto";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { NotificationCoreService } from "./notification-core.service";

export class NotificationErrorService {
  /**
   * An error from any of our external systems (e.g our backend) which is not explicitly handled, will display a generic error notification.
   * The generic error notification is created in the {@link NotificationCoreService}.
   *
   * This might be a good default but sometimes we want to add our own custom notification and handle a certain type of error ourself (explicitly).
   * This method decides if a error from an external system is being handled explicitly (custom logic) or implicitly (by creating the generic error notification).
   */
  static isErrorHandledExplicitly(error: Exception | Error | undefined) {
    const hasApplicationCreationFailedDueToMissingUnderwritingQuestions =
      NotificationErrorService.hasApplicationCreationFailedDueToMissingUnderwritingQuestions(
        error,
      );

    return hasApplicationCreationFailedDueToMissingUnderwritingQuestions;
  }

  /**
   * If the exception from our backend contains the {@link ApplicantDto.hasUnderwritingQuestionsPassed} property as part of its data, we know that they need to be answered again.
   */
  static hasApplicationCreationFailedDueToMissingUnderwritingQuestions(
    error: Exception | Error | undefined,
  ) {
    if (this.isApplicationCreationFailedException(error)) {
      const hasUnderwritingQuestionsPassedProperty = getKey<ApplicantDto>(
        "hasUnderwritingQuestionsPassed",
      );

      return error.data.properties.includes(
        hasUnderwritingQuestionsPassedProperty,
      );
    }

    return false;
  }

  private static isApplicationCreationFailedException(
    error: Exception | Error | undefined,
  ): error is CreateApplicationFailedException {
    return error?.name === ExceptionName.CREATE_APPLICATION_FAILED;
  }
}
